import { Grid, GridItem } from '@chakra-ui/react';
import React, { useContext, useMemo, useState } from 'react';
import { DialogStateContext } from '../../../../context/DialogStateContextProvider';
import { FliterContext } from '../../../../context/FliterContextProvider';
import { TransitsContext } from '../../../../context/TransitsContextProvider';
import { Note } from './Note';
import { Header } from './Header';
import { Schedule } from './Schedule';
import { TrainInfo } from './TrainInfo';
import { Trains } from './Trains';
import UpdateTime from './UpdateTime';

const PlaceInfoDialog: React.FC = () => {
  const { dialogState } = useContext(DialogStateContext);
  const { transits } = useContext(TransitsContext);
  const { filter } = useContext(FliterContext);

  const placeInfo = useMemo(
    () =>
      filter === 'LowFloor'
        ? transits.dialog_places_low_floor[dialogState.selectedPlace]
        : transits.dialog_places[dialogState.selectedPlace],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const [trainInfo, setTrainInfo] = useState(
    placeInfo.trains[dialogState.selectedTrain]
  );

  return (
    <>
      <Grid
        w='100%'
        h='100%'
        gridTemplateAreas={`'header' 'trains' 'trainInfo' 'note' '...' 'schedule' '...' 'updatetime'`}
        gridTemplateRows={`40px 75px 80px 40px 5px 1fr 0px 25px`}
        gridTemplateColumns={`100%`}
      >
        <GridItem gridArea='header'>
          <Header placeInfo={placeInfo} trainInfo={trainInfo}></Header>
        </GridItem>

        <GridItem
          gridArea='trains'
          margin='0 5px'
          borderBottom='solid lightgrey 2px'
        >
          <Trains
            placeInfo={placeInfo}
            trainInfo={trainInfo}
            setTrainInfo={setTrainInfo}
          ></Trains>
        </GridItem>

        <GridItem
          gridArea='trainInfo'
          margin='0 5px'
          borderBottom='solid lightgrey 2px'
        >
          <TrainInfo trainInfo={trainInfo}></TrainInfo>
        </GridItem>

        <GridItem
          gridArea='note'
          margin='0 5px'
          borderBottom='solid lightgrey 2px'
        >
          <Note></Note>
        </GridItem>

        {/* 直接コンポーネントを置かないとScheduleのoverflowYが効かない */}
        <Schedule placeInfo={placeInfo} trainInfo={trainInfo}></Schedule>

        <GridItem gridArea='updatetime'>
          <UpdateTime></UpdateTime>
        </GridItem>
      </Grid>
    </>
  );
};

export default React.memo(PlaceInfoDialog);
